import * as React from "react";

export const ArrowUpward = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <mask
        id="mask0_1562_5001"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="25"
      >
        <rect y="0.3125" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1562_5001)">
        <path
          d="M6.4 18.3125L5 16.9125L14.6 7.3125H6V5.3125H18V17.3125H16V8.7125L6.4 18.3125Z"
          fill="#6B7280"
        />
      </g>
    </svg>
  );
};
export default ArrowUpward;
